import clsx from "clsx"
import classes from "./TextInput.module.scss"

interface TextInputProps
  extends Omit<
    React.DetailedHTMLProps<
      React.InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >,
    "onChange"
  > {
  label?: string
  placeholder?: string
  error?: string
  helper?: string

  onChange?(value: any): void

  onFileChange?(file: any): void
}

const TextInput = (props: TextInputProps) => {
  const { placeholder, error, helper, label, onChange, onFileChange, ...rest } = props

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const isFile = rest.type === "file"
    if (isFile) {
      const file = e.currentTarget.files?.[0]
      if (file) {
        onFileChange?.(file)
      }
      // Do not propagate string value for file inputs
      return
    }
    onChange?.(e.currentTarget.value)
  }

  return (
    <div className={classes.root}>
      {label && <label htmlFor={rest.id} className={classes.label}>{label} {rest.required && <span className={classes.required}>*</span>}</label>}
      <div className={clsx (classes.inputWrapper, { [classes.errorInput]: !!error })}>
        <input
          {...rest}
          type={(rest as any).type || "text"}
          placeholder={placeholder}
          className={clsx(classes.input)}
          onChange={handleChange}
          // Avoid controlling value for file inputs (Android refresh issues)
          {...(((rest as any).type === "file")
            ? { value: undefined }
            : {})}
        />
        {/*{rest.required && <span className={classes.required}>שדה חובה</span>}*/}
      </div>
      {error && <p className={classes.error}>{error}</p>}
      {helper && !error && <p className={classes.helper}>{helper}</p>}
    </div>
  )
}

export default TextInput
